import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { $ } from '../../../../../utils/utilities';
import { useViewHeaderStore } from '../../ViewHeader/ViewHeader';
import { transpose, getNewKey } from '../../../../../utils/transpose';
import Icon from '../../../../../components/common/Icon';
import { ReactComponent as MinusIcon } from '../../../../../icons/minus.svg';
import { ReactComponent as PlusIcon } from '../../../../../icons/plus.svg';

const TransposePlugin = ({ target, disabled = false, songId, songIndex, onKeyChange, onManualTranspose }) => {
  const { t } = useTranslation();
  const setSongKey = useViewHeaderStore((state) => state.setSongKey);
  const globalSongKey = useViewHeaderStore((state) => state.songKey);

  // Use local state for per-song transposition if songId is provided
  const [localSongKey, setLocalSongKey] = useState(null);

  // Initialize local key from the DOM when component mounts
  useEffect(() => {
    if (songId !== undefined) {
      // For per-song plugin, get the initial key from the song section
      const songSection = $(target);

      if (songSection) {
        const keyElement = songSection.querySelector('.song-key');

        if (keyElement) {
          const keyText = keyElement.textContent.replace('Key:', '').trim();
          setLocalSongKey(keyText);
        }
      }
    }
  }, [songId, target]);

  const songKey = songId !== undefined ? localSongKey : globalSongKey;

  function getChords() {
    return $(target).getElementsByClassName('chord');
  }

  function handleSemitoneChange(count, direction) {
    if (disabled || !songKey) return;

    const newKey = getNewKey(songKey, direction);
    const semitones = direction === 'up' ? count : -count;

    // Update key state (local for per-song, global for single song)
    if (songId !== undefined) {
      setLocalSongKey(newKey);
      onKeyChange?.(newKey);
    } else {
      setSongKey(newKey);
    }

    // Use React state-based transpose if available, otherwise fallback to DOM
    if (onManualTranspose) {
      onManualTranspose(semitones, songIndex);
    } else {
      // Legacy DOM manipulation
      getChords().forEach((chord) => {
        chord.innerHTML = transpose(chord.innerHTML, songKey, count, direction);
      });
    }
  }

  return (
    <div className={`song-plugin transpose-plugin ${disabled ? 'disabled' : ''}`}>
      <span className="plugin__title">{t('view.transpose')}</span>
      <span
        onClick={() => handleSemitoneChange(1, 'down')}
        className={`btn-decrease-value ${disabled ? 'disabled' : ''}`}
      >
        <Icon icon={<MinusIcon />} />
      </span>
      <span className="display-value">1/2</span>
      <span
        onClick={() => handleSemitoneChange(1, 'up')}
        className={`btn-increase-value ${disabled ? 'disabled' : ''}`}
      >
        <Icon icon={<PlusIcon />} />
      </span>
    </div>
  );
};

TransposePlugin.propTypes = {
  target: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  songId: PropTypes.string,
  songIndex: PropTypes.number,
  onKeyChange: PropTypes.func,
  onManualTranspose: PropTypes.func,
};

export default TransposePlugin;
